/**
 * I caratteri speciali ammessi nelle password
 */
export const passwordAllowedSpecialCharacters: string[] = [
    "&",
    "%",
    "$",
    "@",
    "#",
    "*",
    "-",
    ".",
    ":",
    ";",
    "!",
    "?",
]
